import React from "react"
import * as O from "fp-ts/Option"

export default function ({
  name,
  label,
  error,
  onChangeMsg,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement> & {
  name: string
  label: string
  error: O.Option<string>
  dataCy: string
  onChangeMsg: (event: { target: HTMLInputElement }) => void
}): JSX.Element {
  const inputRef = React.useRef<HTMLInputElement>(null)
  const uid = props.id || name
  const inputid = props.id || `input-field-${name}`
  const labelid = `input-label-${uid}`
  const errorid = `input-error-${uid}`

  React.useEffect(() => {
    if (O.isNone(error)) return
    inputRef.current?.focus()
  }, [error])

  return (
    <div>
      <div
        className={
          "flex justify-between mb-2" + (O.isSome(error) ? " text-brick" : "")
        }
      >
        <label id={labelid} htmlFor={inputid}>
          {label}
        </label>
        {O.match(
          () => <></>,
          err => (
            <p
              id={errorid}
              className=" font-deia leading-none"
              data-cy={`${props.dataCy}-error`}
            >
              {err}
            </p>
          )
        )(error)}
      </div>
      <input
        value={props.value}
        ref={inputRef}
        type={props.type}
        id={inputid}
        name={name}
        placeholder={props.placeholder}
        autoComplete="off"
        onChange={onChangeMsg}
        className={props.className}
        aria-describedby={O.isSome(error) ? errorid : undefined}
        aria-invalid={O.isSome(error)}
        data-cy={props.dataCy}
      />
    </div>
  )
}
